var map = {
	"./1.webp": 16045,
	"./10.webp": 31267,
	"./11.webp": 76395,
	"./12.webp": 79426,
	"./13.webp": 73562,
	"./14.webp": 97019,
	"./15.webp": 31553,
	"./16.webp": 59556,
	"./17.webp": 22766,
	"./18.webp": 54839,
	"./19.webp": 16930,
	"./2.webp": 25279,
	"./20.webp": 54594,
	"./21.webp": 76828,
	"./22.webp": 54490,
	"./23.webp": 58670,
	"./24.webp": 4141,
	"./25.webp": 98118,
	"./26.webp": 78462,
	"./27.webp": 49611,
	"./28.webp": 30785,
	"./29.webp": 88818,
	"./3.webp": 12220,
	"./30.webp": 10687,
	"./4.webp": 34075,
	"./5.webp": 41719,
	"./6.webp": 38577,
	"./7.webp": 94180,
	"./8.webp": 13195,
	"./9.webp": 91458,
	"./black.webp": 21167,
	"./black1.webp": 49411,
	"./bs.webp": 36126,
	"./kanstik2.webp": 58457,
	"./print.webp": 71600,
	"./tib.webp": 89921
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3970;